import { Offer } from '@fourthwall/services/dist/models/offer'

export const getSamplesOffersQueryParams = ({
  size = 1_000,
  query,
  includeFulfillmentService = true,
}: {
  size?: number
  query?: string
  includeFulfillmentService?: boolean
}) => ({
  size,
  status: Offer.OFFER_STATUSES_WITH_SAMPLES,
  fulfillmentService: includeFulfillmentService
    ? Offer.FULFILLING_SERVICES_WITH_SAMPLES
    : undefined,
  q: !!query?.length && query.length > 2 ? query : undefined,
  includeEmbeddedOffers: true,
})
